var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.277478 0.277478C0.647448 -0.0924926 1.24729 -0.0924926 1.61726 0.277478L11.7225 10.3827C12.0925 10.7527 12.0925 11.3526 11.7225 11.7225C11.3526 12.0925 10.7527 12.0925 10.3827 11.7225L0.277478 1.61726C-0.0924926 1.24729 -0.0924926 0.647448 0.277478 0.277478Z",
    fill: "#707683"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7225 0.277478C12.0925 0.647448 12.0925 1.24729 11.7225 1.61726L1.61726 11.7225C1.24729 12.0925 0.647448 12.0925 0.277478 11.7225C-0.0924926 11.3526 -0.0924926 10.7527 0.277478 10.3827L10.3827 0.277478C10.7527 -0.0924926 11.3526 -0.0924926 11.7225 0.277478Z",
    fill: "#707683"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewClose);
export default __webpack_public_path__ + "static/media/new_close.3a33be4f.svg";
export { ForwardRef as ReactComponent };